import { useEffect, useState } from "react";
import { AlertTriangle, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ULOG_SEV } from "@/lib/flightSessions";

// ULOG.OBS.4 — bannière d'alertes LECTURE SEULE (aucun e-mail/push, aucune action drone).
// Seule action : copier la commande de DIAGNOSTIC (status, lecture seule) à exécuter sur le Raspberry.
export const UlogIntegrityAlerts = ({ refreshKey }) => {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/flight-sessions/integrity-alerts")
      .then(({ data }) => setAlerts(data?.alerts || []))
      .catch(() => setAlerts([]));
  }, [refreshKey]);
  if (!alerts.length) return null;
  const copy = (cmd) => {
    navigator.clipboard?.writeText(cmd).then(() => toast.success("Commande copiée"), () => toast.error("Copie impossible"));
  };
  return (
    <div className="mb-4 border border-[#F59E0B]/30 bg-[#F59E0B]/[0.04] rounded-sm p-3" data-testid="fs-integrity-alerts">
      <div className="flex items-center gap-2 mb-2 font-mono text-[10px] tracking-[0.15em] uppercase text-[#F59E0B]">
        <AlertTriangle size={13} /> Alertes d'intégrité ULog ({alerts.length})
      </div>
      <div className="space-y-1.5">
        {alerts.map((a) => {
          const sev = ULOG_SEV[a.severity] || ULOG_SEV.INFO;
          return (
            <div key={`${a.drone_id}/${a.session_id}`} data-testid={`fs-alert-${a.session_id}`}
              className="flex flex-wrap items-center gap-2 font-mono text-[11px]">
              <span data-testid={`fs-alert-sev-${a.session_id}`} className="px-1.5 py-0.5 rounded-sm border text-[10px]"
                style={{ color: sev.c, borderColor: sev.c + "55" }}>{sev.l}</span>
              <span className="text-white">{a.drone_id}</span>
              <span className="text-[#737373] truncate max-w-[200px]">{a.session_id}</span>
              <span className="text-[#A3A3A3]">{a.message}</span>
              <button data-testid={`fs-alert-copy-${a.session_id}`} onClick={() => copy(a.diagnostic_command)}
                title={a.diagnostic_command}
                className="ml-auto flex items-center gap-1 text-[10px] uppercase border border-white/15 rounded-sm px-2 py-0.5 hover:bg-white/10 transition-colors">
                <Copy size={11} /> Commande diagnostic
              </button>
            </div>
          );
        })}
      </div>
      <div className="mt-2 font-mono text-[9px] text-[#525252]">
        Couverture : sessions uploadées uniquement. Les sessions bloquées sur le drone se diagnostiquent avec la CLI locale.
      </div>
    </div>
  );
};
